import { useCallback, useMemo } from 'react'
import { useModal } from '~/hooks/useModal'
import { ShopType } from '~/lib/shopType'
import { buildShopListUrl } from '../../../shop/buildShopListUrl'
import { NormalizedConditions } from '../../../shop/types'
import { NormalizedBrand } from '../../../types'
import { BrandFilter } from './BrandFilter'
import { BrandSelector } from './BrandSelector'
import { ShopTypeFilter } from './ShopTypeFilter'

type Props = {
  conditions: NormalizedConditions
}

export const ShopFilterPanel: React.FC<Props> = ({ conditions }) => {
  const { shopType, brand } = conditions

  const [Modal, open, close, isOpen] = useModal(200, {
    preventScroll: false,
  })

  const buildShopTypeFilterUrl = useCallback(
    (_shopType: ShopType) =>
      buildShopListUrl({
        ...conditions,
        shopType: _shopType,
      }),
    [conditions]
  )

  const buildBrandFilterUrl = useCallback(
    (_brand: NormalizedBrand) =>
      buildShopListUrl({
        ...conditions,
        brand: _brand,
        additionalQueries: [],
      }),
    [conditions]
  )

  const unselectedBrandUrl = useMemo(() => {
    return buildShopListUrl({
      ...conditions,
      brand: undefined,
      additionalQueries: [],
    })
  }, [conditions])

  return (
    <>
      <nav className="flex w-[234px] flex-col gap-y-[30px] rounded-[3px] border border-gray-300 bg-white pb-5 pt-[19px]">
        <h2 className="sr-only">絞り込み条件</h2>
        <div className="pl-[19px] pt-[2px]">
          <ShopTypeFilter
            selectedShopType={shopType}
            buildUrl={buildShopTypeFilterUrl}
          />
        </div>
        <BrandFilter
          brandName={brand?.name}
          onSelectBrandClick={open}
          unselectedUrl={unselectedBrandUrl}
          title="取り扱いブランド"
        />
      </nav>
      <Modal
        overlayClassName={`ease-linear duration-200 bg-black transition-opacity ${
          isOpen ? 'opacity-60' : 'opacity-0'
        }`}
        className={`w-[910px] ${
          isOpen
            ? 'scale-100 opacity-100 transition delay-100 duration-100 ease-linear'
            : 'scale-90 opacity-0'
        }`}
      >
        <BrandSelector buildUrl={buildBrandFilterUrl} onCloseClick={close} />
      </Modal>
    </>
  )
}
